import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../assets/config';
import './Services.css';

const Services = () => {
  const detailedServices = [
    {
      title: "Architecture Design",
      icon: "🏗️",
      description: "Complete architectural solutions from concept to completion",
      features: [
        "Conceptual design and planning",
        "Detailed architectural drawings",
        "3D modeling and visualization",
        "Building code compliance",
        "Construction documentation",
        "Project coordination"
      ],
      price: "Starting from ₹50,000"
    },
    {
      title: "Interior Design",
      icon: "🏠",
      description: "Beautiful and functional interior spaces",
      features: [
        "Space planning and layout",
        "Color scheme and material selection",
        "Furniture and fixture design",
        "Lighting design",
        "Custom furniture design",
        "Installation supervision"
      ],
      price: "Starting from ₹30,000"
    },
    {
      title: "Space Planning",
      icon: "📐",
      description: "Optimal space utilization and flow",
      features: [
        "Functional space analysis",
        "Traffic flow optimization",
        "Storage solutions",
        "Multi-purpose design",
        "Accessibility compliance",
        "Efficiency improvements"
      ],
      price: "Starting from ₹20,000"
    },
    {
      title: "Project Management",
      icon: "📋",
      description: "End-to-end project coordination and execution",
      features: [
        "Timeline management",
        "Budget control and tracking",
        "Contractor coordination",
        "Quality assurance",
        "Progress monitoring",
        "Client communication"
      ],
      price: "Starting from ₹40,000"
    },
    {
      title: "Renovation & Remodeling",
      icon: "🔨",
      description: "Transform existing spaces with modern design",
      features: [
        "Existing space analysis",
        "Renovation planning",
        "Structural modifications",
        "Material selection",
        "Construction oversight",
        "Final finishing"
      ],
      price: "Starting from ₹35,000"
    },
    {
      title: "Consultation Services",
      icon: "💡",
      description: "Expert advice for your design projects",
      features: [
        "Design consultation",
        "Material recommendations",
        "Budget planning",
        "Vendor recommendations",
        "Design review",
        "Ongoing support"
      ],
      price: "Starting from ₹5,000"
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="services-hero-content">
            <h1>Our Services</h1>
            <p>Comprehensive design solutions tailored to your needs</p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section services-grid-section">
        <div className="container">
          <div className="section-title">
            <h2>What We Offer</h2>
            <p>Professional services to bring your vision to life</p>
          </div>
          <div className="services-grid">
            {detailedServices.map((service, index) => (
              <div key={index} className="service-card-detailed">
                <div className="service-header">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
                <div className="service-features">
                  <h4>What's Included:</h4>
                  <ul>
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>{feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="service-price">
                  <span className="price">{service.price}</span>
                </div>
                <Link to="/contact" className="btn btn-primary">
                  Get Quote
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section process-section">
        <div className="container">
          <div className="section-title">
            <h2>How We Work</h2>
            <p>Our proven process ensures successful project delivery</p>
          </div>
          <div className="process-timeline">
            <div className="timeline-item">
              <div className="timeline-number">1</div>
              <div className="timeline-content">
                <h3>Initial Consultation</h3>
                <p>We meet to understand your vision, requirements, and budget. This helps us create a tailored approach for your project.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">2</div>
              <div className="timeline-content">
                <h3>Concept Development</h3>
                <p>Our team develops initial concepts and presents multiple design options for your review and feedback.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">3</div>
              <div className="timeline-content">
                <h3>Detailed Design</h3>
                <p>We refine the chosen concept with detailed drawings, specifications, and material selections.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">4</div>
              <div className="timeline-content">
                <h3>Project Execution</h3>
                <p>Our experienced team manages the construction process to ensure quality and timely delivery.</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-number">5</div>
              <div className="timeline-content">
                <h3>Final Delivery</h3>
                <p>We ensure everything meets your expectations and provide ongoing support for any questions.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content text-center">
            <h2>Ready to Start Your Project?</h2>
            <p>Get in touch with us for a free consultation and quote</p>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary">
                Get Free Consultation
              </Link>
              <a href={`tel:${siteConfig.contact.phone}`} className="btn btn-secondary">
                Call Now
              </a>
            </div>
                         <div className="contact-info">
               <div className="contact-item">
                 <span className="contact-icon">📧</span>
                 <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
               </div>
             </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 